import { useTranslation } from "react-i18next";
import { getEnvVar, ASSETS_URL } from "@commons-monorepo/index";

import styles from "./empty-state.module.css";

const EmptyState = ({ searchProduct }: {searchProduct: boolean;}) => {
  const { t } = useTranslation();
  const domain = getEnvVar("PUBLIC_HOST");

  return (
    <div className={styles.notFoundContainer} role='not-found'>
      <div className={styles.contentNotProfile}>
        <img
          className={styles.emptyImg}
          src={`${ASSETS_URL}/prod/coupon-templates/empty-state-sumer.webp`} />

        <p className={styles.notResults}>{t("emptyState.not_results")}</p>
        {!searchProduct &&
        <a className={styles.buttonStores} href={`${domain}/directorio`}>
            {t("emptyState.more_stores")}
          </a>}

      </div>
    </div>);

};

export default EmptyState;